import React, { FC, useState } from 'react';
import { COLORS } from '../../config/designSystem/Colors';
import { DropShadowMedium } from '../DropShadows/DropShadowMedium';
import { ToggleElement } from './ToggleElement';
import { View } from 'react-native';


export interface ToggleTabsProps {
  label:string;
  onPress: () => void;
}

export interface ToggleProps {
    indexSelected: number;
    tabs: ToggleTabsProps[];
  }

export const Toggle: FC<ToggleProps>= ({indexSelected, tabs}) => {
  const [globalIndex, setGlobalIndex] = useState<number>(indexSelected);

  const onPressIndex = (index: number) => {
    setGlobalIndex(index);
    tabs[index]?.onPress();
  };
  return(
    <View style={{   alignItems: 'center'}}>
      <View style={{ width: '100%', maxWidth: 500}}>
        <DropShadowMedium >
          <View style={{
            borderRadius: 12,
            borderWidth: 1,
            borderColor: COLORS.border['accent-light'],
            backgroundColor: COLORS.surface.contrast,
            alignItems: 'center',
            padding: 4,
            flexDirection: 'row',
            rowGap: 10,
          }}>
            {tabs.map((tab, index) => {
              return (
                <View key={index} style={{flex: 1}}>
                  <ToggleElement
                    key={index}
                    label={tab.label}
                    selected={index === globalIndex}
                    onPress={() => onPressIndex(index)}
                  />
                </View>
              );
            })}

          </View>
        </DropShadowMedium>
      </View>
    </View>);


};


